import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders, formAuthHeaders } from "../../utils/axios";

// const token =
// localStorage.getItem("auth-token") &&
// JSON.parse(localStorage.getItem("auth-token")).token;

// console.log("token==>",token);


export const addNpaProperties = createAsyncThunk("property/addNpaProperties",async (data, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/api/bank/properties/add`,data,formAuthHeaders());
      return response.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const updateNpaProperties = createAsyncThunk("property/updateNpaProperties",async ({ id, data}, { rejectWithValue }) => {
    try {
      const response = await Axios.put(`/api/bank/properties/update/${id}`,data,formAuthHeaders());
      return response.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const deleteNpaProperties = createAsyncThunk("property/deleteNpaProperties",async ({ id }, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(`/api/bank/properties/delete/${id}`,authHeaders());
      return response.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const npaPropertiesList = createAsyncThunk("property/npaPropertiesList",async ({ page, limit, status, search, asset_category, property_type, possession_type, city_town, reserve_price}, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/bank/properties/list?status=${status || ""}&limit=${limit || 10}&page=${page || 1}&search=${search || ""}&asset_category=${asset_category || ""}&property_type=${property_type || ""}&possession_type=${possession_type || ""}&city_town=${city_town || ""}&reserve_price=${reserve_price || ""}`,authHeaders());
      return response.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const propertyDetails = createAsyncThunk("property/propertyDetails",async ({ id }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/bank/properties/${id}`,authHeaders());
      return response.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  }
);

export const reqToGetFilterData = createAsyncThunk("auth/reqToGetFilterData",async ({ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/api/bank/filters/metadata`,authHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const reqToImportNpaProperties = createAsyncThunk("property/reqToImportNpaProperties",async (data,{ rejectWithValue }) => {
    try {
      const response = await Axios.post(`/api/bank/properties/bulk-insert`,data,formAuthHeaders());
      return response?.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  });

  export const propertyTypesDropdown = createAsyncThunk("properties/propertyTypesDropdown",async ({ rejectWithValue }) => {
    try {
      const response = await Axios.get(`/api/bank/properties/dropdowns`,authHeaders());
      return response?.data; // Success case
    } catch (error) {
      return rejectWithValue(error.response.data); // Error case
    }
  });

const propertySlice = createSlice({
  name: "property",
  initialState: {
    isLoading: false,
    error: null,
    addProperty: {},
    propertyList: [],
    propertyDetail: {},
    filter:{},
    propertyDropdown:[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add NPA Property
      .addCase(addNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addProperty = action.payload;
      })
      // NPA Properties List
      .addCase(npaPropertiesList.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(npaPropertiesList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyList = action.payload;
      })
      .addCase(npaPropertiesList.rejected, (state, action) => {
        state.isLoading = false;
      })
      // NPA Property Details
      .addCase(propertyDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyDetail = action.payload;
      }) 
      // request to fetch filter data
      .addCase(reqToGetFilterData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.filter = action.payload;
      })
       // request to Types of property Dropdown
       .addCase(propertyTypesDropdown.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyDropdown = action.payload;
      })
  },
});

export default propertySlice.reducer;
